<ng-container *ngIf="!errorType"><iframe [ngStyle]="{ height: fileHeight }" [src]="src | safe: 'resource'"></iframe></ng-container>

<ng-container *ngIf="errorType">
  <error-preview
    [errorType]="errorType"
    [previewMode]="previewMode"
    [icon]="model.icon"
    (reload)="reload.emit()"
    (download)="download.emit()"
  >
  </error-preview>
</ng-container>
